var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-user-home" },
    [
      _vm.user
        ? _c("div", { staticClass: "user-item user-info" }, [
            _c("p", { staticClass: "title" }, [_vm._v("考生信息")]),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "left" },
                [
                  _vm.user.userId
                    ? _c("el-avatar", {
                        attrs: {
                          src:
                            "/oua2/getUserPhoto?type=relativePath&userId=" +
                            _vm.user.userId,
                          size: 60,
                        },
                      })
                    : _vm._e(),
                  _vm.user.sexValue == 0
                    ? _c("i", { staticClass: "icon iconfont icon-icon_man" })
                    : _c("i", { staticClass: "icon iconfont icon-icon_woman" }),
                ],
                1
              ),
              _c("div", { staticClass: "right" }, [
                _c("p", { staticClass: "sub" }, [
                  _c("span", [_vm._v(_vm._s(_vm.user.name))]),
                ]),
                _c("p", { staticClass: "info" }, [
                  _c("span", { staticClass: "info-item" }, [
                    _c("i", { staticClass: "iconfont icon-icon_phonenumber" }),
                    _vm._v(" " + _vm._s(_vm.user.phone) + " "),
                  ]),
                  _c("span", { staticClass: "info-item" }, [
                    _c("i", { staticClass: "iconfont icon-icon_id" }),
                    _vm._v(" " + _vm._s(_vm.user.idCard) + " "),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "DsfVirtualScroll",
        { staticClass: "list" },
        [
          _vm._l(_vm.data, function (item, index) {
            return [
              item.type == 0 || (item.type == 1 && _vm.trainingType)
                ? _c(
                    "div",
                    { key: index, staticClass: "user-item" },
                    [
                      _c("p", { staticClass: "title" }, [
                        _c("span", [
                          _vm._v(
                            "正在进行中的" +
                              _vm._s(item.type === 0 ? "考试" : "练习")
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "more",
                            on: {
                              click: function ($event) {
                                return _vm.goMore(item.type)
                              },
                            },
                          },
                          [_vm._v("更多 >")]
                        ),
                      ]),
                      _vm._l(item.homeInfoDtos, function (home, homeIndex) {
                        return _c(
                          "div",
                          { key: homeIndex, staticClass: "content" },
                          [
                            _c("div", { staticClass: "left" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "icon-svg",
                                  class: {
                                    exam: item.type === 0,
                                    practice: item.type === 1,
                                  },
                                },
                                [
                                  item.type === 0
                                    ? _c("img", {
                                        staticClass: "icon",
                                        attrs: {
                                          src: "/static/img/icon_ks.png",
                                          alt: "",
                                        },
                                      })
                                    : item.type === 1
                                    ? _c("img", {
                                        staticClass: "icon",
                                        attrs: {
                                          src: "/static/img/icon_lx.png",
                                          alt: "",
                                        },
                                      })
                                    : _c("img", {
                                        staticClass: "icon",
                                        attrs: {
                                          src: "/static/img/icon_zy.png",
                                          alt: "",
                                        },
                                      }),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "right" }, [
                              _c("p", { staticClass: "sub" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(home.name) +
                                      " " +
                                      _vm._s(
                                        home.batchName
                                          ? " " + home.batchName
                                          : ""
                                      )
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "operate" }, [
                                _c("span", { staticClass: "time" }, [
                                  _vm._v(_vm._s(home.examDateTime)),
                                ]),
                                item.type === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "btns" },
                                      [
                                        home.isExist == "1"
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: {
                                                  type: "plain",
                                                  title: "查看结果",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getResult(
                                                      home,
                                                      item.type
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看结果")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "DsfButton",
                                          {
                                            attrs: {
                                              type: "plain",
                                              title: "考生须知",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.getRules(home)
                                              },
                                            },
                                          },
                                          [_vm._v("考生须知")]
                                        ),
                                        home["viewStatus"] == 2
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: { title: "继续考试" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.continueExam(
                                                      home,
                                                      item.type
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("继续考试")]
                                            )
                                          : _vm._e(),
                                        home.viewStatus == 1 ||
                                        home.viewStatus == 4
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: {
                                                  title: "进入考试",
                                                  disabled:
                                                    home.viewStatus == 4 ||
                                                    _vm.remainTimes(
                                                      home.list
                                                    ) == 0,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goDetail(
                                                      home,
                                                      item.type
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("进入考试")]
                                            )
                                          : _vm._e(),
                                        home.viewStatus === 3
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: {
                                                  title: "未开始",
                                                  disabled:
                                                    home.viewStatus === 3,
                                                },
                                              },
                                              [_vm._v("未开始")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : item.type === 1
                                  ? _c(
                                      "div",
                                      { staticClass: "btns" },
                                      [
                                        home.isExist == "1"
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: {
                                                  type: "plain",
                                                  title: "查看练习",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getResult(
                                                      home,
                                                      item.type
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("查看练习")]
                                            )
                                          : _vm._e(),
                                        home.viewStatus === 2
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: { title: "继续练习" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goDetail(
                                                      home,
                                                      item.type,
                                                      2
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("继续练习")]
                                            )
                                          : _vm._e(),
                                        home.viewStatus === 1 ||
                                        home.viewStatus === 4
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: {
                                                  title: "进入练习",
                                                  disabled:
                                                    home.viewStatus === 4 ||
                                                    _vm.trainingNum(
                                                      home.list
                                                    ) == 0,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goDetail(
                                                      home,
                                                      item.type,
                                                      1
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("进入练习")]
                                            )
                                          : _vm._e(),
                                        _vm.trainingNum(home.list) == 0
                                          ? _c(
                                              "DsfButton",
                                              {
                                                attrs: { title: "提示" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.trainingTips()
                                                  },
                                                },
                                              },
                                              [_vm._v("提示")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                "div",
                                { staticClass: "count" },
                                _vm._l(home.list, function (li, liIndex) {
                                  return _c(
                                    "div",
                                    { key: liIndex, staticClass: "item" },
                                    [
                                      _c("p", { staticClass: "total" }, [
                                        _vm._v(" " + _vm._s(li.value)),
                                        _c("span", { staticClass: "unit" }, [
                                          _vm._v(_vm._s(li.unit)),
                                        ]),
                                      ]),
                                      _c("p", { staticClass: "tips" }, [
                                        _vm._v(_vm._s(li.text)),
                                      ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }